import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { getCurrentFolderHome } from 'reactApp/modules/home/home.selectors';
import { getAutoDeleteFoldersInfo } from 'reactApp/modules/sharedAutoDelete/sharedAutoDelete.selectors';
import type { IAutoDeleteFoldersInfo } from 'reactApp/modules/sharedAutoDelete/sharedAutoDelete.type';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';
import { AutoDeleteFolderInformer, autoDeleteInformerId } from 'reactApp/ui/AutoDeleteFolderInformer/AutoDeleteFolderInformer';
import { HasExpiredSubscriptionInformer } from 'reactApp/ui/HasExpiredSubscriptionInformer/HasExpiredSubscriptionInformer';
import { HasSubscriptionInformer } from 'reactApp/ui/HasSubscriptionInformer/HasSubscriptionInformer';
import { useSubscriptionInformerInfo } from 'reactApp/ui/HasSubscriptionInformer/useSubscriptionInformerInfo';

export const useHomeInformers = (isHome) => {
    const dispatch = useDispatch();
    const item = useSelector(getCurrentFolderHome);
    const { isFolder } = item || {};
    const subscriptionInfo = useSubscriptionInformerInfo();
    const foldersInfo: IAutoDeleteFoldersInfo = useSelector(getAutoDeleteFoldersInfo);

    const autodeleteInformerShown = dispatch(UserStorageActions.get(autoDeleteInformerId)) as unknown as number;

    if (!isHome) {
        return null;
    }

    if (item && isFolder && autodeleteInformerShown < new Date().valueOf()) {
        const isRoot = item.id === ROOT_FOLDER_ID;

        if ((isRoot && foldersInfo.folderCount && autodeleteInformerShown < new Date().valueOf()) || (!isRoot && item.weblinkAutoDelete)) {
            return <AutoDeleteFolderInformer item={item} />;
        }
    }

    if (subscriptionInfo?.subscription) {
        return <HasSubscriptionInformer subscription={subscriptionInfo.subscription} />;
    }

    if (subscriptionInfo?.productId) {
        return <HasExpiredSubscriptionInformer productId={subscriptionInfo.productId} />;
    }
};
